import { useCurrentRole } from '../store'
import { hasRequiredRole } from '../utils/user'

import type { Role } from '../types'
import type { PropsWithChildren } from 'react'

/**
 * Component that renders its children only if the user has the required role
 */
export const HasRole = ({
	children,
	role,
	fallback,
}: PropsWithChildren<{ role: Role; fallback?: React.ReactNode }>) => {
	const userRole = useCurrentRole()

	if (!hasRequiredRole(userRole, role)) {
		return fallback ?? null
	}

	return <>{children}</>
}
